import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import { PROD, SENTRY_DNS_KEY, STAGE } from './env';
import MainApp from './MainApp';

Sentry.init({
  enabled: PROD && STAGE !== 'development',
  environment: STAGE,
  release: APP_VERSION,
  dsn: SENTRY_DNS_KEY,
});

const root = ReactDOM.createRoot(document.getElementById('app-site'));
root.render(<MainApp />);
